import styled from "styled-components";
import { ColorVariables } from "manifest-components/src/Colors";
import { useContext, useEffect, useMemo, useState } from "react";
import AppContainer from "../Layout/AppContainer";
import HeaderAuth from "./HeaderAuth";
import HeaderDefault from "./HeaderDefault";
import { AppContext } from "../../context/App/appProvider";

export const HeaderHeight = 80;

const StyledHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: ${HeaderHeight}px;
  display: flex;
  background: ${ColorVariables.background};
  z-index: 1000;
  .manifestLogo {
    height: 20px;
    width: 100px;
  }
  &.default {
    position: absolute;
  }
  &.auth {
    background: #ffe8c8;
    border-bottom: 1px solid rgba(46, 45, 41, 0.1);
  }
  &.noBackground {
    position: absolute;
    background: transparent;
  }
  &.shadow {
    box-shadow: 0 0 20px 10px ${ColorVariables.coco1};
  }
`;

const StyledAppContainer = styled(AppContainer)`
  display: flex;
  justify-content: start;
  > *:first-child {
    margin: auto 0;
  }
`;

type HeaderProps = {
  isAuthenticated?: boolean;
  isVerified?: boolean;
};

export default function Header(props: HeaderProps) {
  const { isAuthenticated, isVerified = true } = props;
  const { headerClass } = useContext(AppContext);
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    setScrollPosition(window.pageYOffset);
  };

  const updateScrollPosition = () => {
    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });
  };

  const computedClassNames = useMemo(() => {
    const classNames: string[] = [headerClass];
    if (isAuthenticated) {
      classNames.push("auth");
    } else {
      classNames.push("default");
    }
    if (scrollPosition > 10 && headerClass !== "noBackground") {
      classNames.push("shadow");
    }
    return classNames.join(" ");
  }, [scrollPosition, headerClass, isAuthenticated]);

  useEffect(() => {
    updateScrollPosition();
  }, []);

  return (
    <StyledHeader id="header" className={computedClassNames}>
      <StyledAppContainer>
        {isAuthenticated ? <HeaderAuth isVerified={isVerified} /> : <HeaderDefault />}
      </StyledAppContainer>
    </StyledHeader>
  );
}
